import {
  ICreateInlineBlockDetectionDto,
  ISubmitInlineBlockDetectionDto,
  IInlineBlockDetectionRun,
} from '../types/inlineBlocks.types';
import { makeDetectionApiHooks } from './shared.api';

const { useCreateDetection, usePollDetection, useSubmitDetection, useCancelDetection } = makeDetectionApiHooks<
  ICreateInlineBlockDetectionDto,
  IInlineBlockDetectionRun,
  ISubmitInlineBlockDetectionDto
>({
  ns: 'inline-blocks',
  basePath: '/detections/inline-blocks',
  messages: {
    startedSuccess: 'Library detection run started.',
    startError: 'Failed to start library detection!',
    lockedWarning: 'Some documents are locked by other users.',

    submitSuccess: 'Library items submitted.',
    submitError: 'Failed to submit library items!',

    cancelSuccess: 'Library detection run cancelled.',
    cancelError: 'Failed to cancel library detection!',

    loadErrorTitle: 'Failed to load library detection run!',
    loadErrorToast: 'Loading library detection failed!',
  },
});

export const useCreateInlineBlockDetection = useCreateDetection;
export const usePollInlineBlockDetection = usePollDetection;
export const useSubmitInlineBlockDetection = useSubmitDetection;
export const useCancelInlineBlockDetection = useCancelDetection;
